import { ReactNode } from 'react';
import CompanyInfoNoData from 'src/features/CompanyDetail/Common/CompanyInfoNoData';

interface DataGuardProps {
  children: ReactNode;
  shouldRenderEmpty: () => boolean;
  emptyTitle?: string;
  emptyContent?: ReactNode;
}

const DataGuard = ({ children, shouldRenderEmpty, emptyTitle, emptyContent }: DataGuardProps) => {
  if (shouldRenderEmpty())
    return (
      <CompanyInfoNoData
        title={emptyTitle ?? 'Trade Data Not Found'}
        content={
          emptyContent ?? (
            <>
              Customs data may be restricted, incomplete, or obscured by alternative trading names or third-party
              logistics.
            </>
          )
        }
        sxContainer={{
          borderWidth: 0,
        }}
      />
    );
  return <>{children}</>;
};

export default DataGuard;
